/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_NL_NL: Record<string, string> = {
    ariaAnnounceChart: 'grafiek, ${seriesCount}[number] reeksen',
    ariaAnnounceFlowProportionLink: 'link ${index} van ${count}, van ${from} naar ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'knooppunt ${index} van ${count}, ${description}',
    ariaAnnounceGaugeChart: 'meterdiagram, ${caption}',
    ariaAnnounceHierarchyChart: 'hiërarchie diagram, ${caption}',
    ariaAnnounceHierarchyDatum: 'niveau ${level}[number], ${count}[number] kinderen, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Druk op Spatie of Enter om zichtbaarheid te wisselen',
    ariaLabelAddHorizontalLine: 'Horizontale Lijn Toevoegen',
    ariaLabelAnnotationOptionsToolbar: 'Annotatie-opties',
    ariaLabelAnnotationSettingsDialog: 'Annotatie-instellingen',
    ariaLabelColorPicker: 'Kleurkiezer',
    ariaLabelFinancialCharts: 'Financiële grafieken',
    ariaLabelLegend: 'Legenda',
    ariaLabelLegendItem: '${label}, Legenda-item ${index}[number] van ${count}[number]',
    ariaLabelLegendItemUnknown: 'Onbekend legende-item',
    ariaLabelLegendPageNext: 'Volgende Legend Pagina',
    ariaLabelLegendPagePrevious: 'Vorige Legenda Pagina',
    ariaLabelLegendPagination: 'Legenda Paginering',
    ariaLabelNavigator: 'Navigator',
    ariaLabelNavigatorMaximum: 'Maximum',
    ariaLabelNavigatorMinimum: 'Minimum',
    ariaLabelNavigatorRange: 'Bereik',
    ariaLabelRangesToolbar: 'Bereiken',
    ariaLabelSettingsTabBar: 'Instellingen',
    ariaLabelZoomToolbar: 'Zoom',
    ariaValuePanRange: '${min}[percent0to2dp] tot ${max}[percent0to2dp]',
    contextMenuDownload: 'Downloaden',
    contextMenuPanToCursor: 'Naar hier pannen',
    contextMenuToggleOtherSeries: 'Andere series in-/uitschakelen',
    contextMenuToggleSeriesVisibility: 'Zichtbaarheid Wijzigen',
    contextMenuZoomToCursor: 'Hier inzoomen',
    dialogHeaderChannel: 'Kanaal',
    dialogHeaderDatePriceRange: 'Datum en Prijs',
    dialogHeaderDateRange: 'Datumbereik',
    dialogHeaderFibonacciRange: 'Fib Retracement',
    dialogHeaderLine: 'Lijn',
    dialogHeaderPriceRange: 'Prijsklasse',
    dialogHeaderText: 'Tekst',
    dialogInputAlign: 'Uitlijnen',
    dialogInputColorPicker: 'Kleur',
    dialogInputColorPickerAltText: 'Tekstkleur',
    dialogInputExtendAbove: 'Boven uitbreiden',
    dialogInputExtendBelow: 'Naar beneden uitbreiden',
    dialogInputExtendChannelEnd: 'Kanaaleinde uitbreiden',
    dialogInputExtendChannelStart: 'Kanaalstart verlengen',
    dialogInputExtendLeft: 'Links uitbreiden',
    dialogInputExtendLineEnd: 'Verleng lijneinde',
    dialogInputExtendLineStart: 'Lijnbegin verlengen',
    dialogInputExtendRight: 'Naar rechts uitbreiden',
    dialogInputFibonacciBands: 'Banden',
    dialogInputFibonacciBandsAltText: 'Fibonacci Banden',
    dialogInputFillColorPicker: 'Vul',
    dialogInputFillColorPickerAltText: 'Vulkleur',
    dialogInputFontSize: 'Grootte',
    dialogInputFontSizeAltText: 'Lettergrootte',
    dialogInputLineStyle: 'Streep',
    dialogInputPosition: 'Positie',
    dialogInputReverse: 'Omkeren',
    dialogInputShowFill: 'Inkleuren weergeven',
    dialogInputStrokeWidth: 'Gewicht',
    dialogInputStrokeWidthAltText: 'Lijndikte',
    iconAltTextAlignCenter: 'Centreren',
    iconAltTextAlignLeft: 'Links',
    iconAltTextAlignRight: 'Rechts',
    iconAltTextClose: 'Sluiten',
    iconAltTextLineStyleDashed: 'Lang-gestreept',
    iconAltTextLineStyleDotted: 'Kort-gestreept',
    iconAltTextLineStyleSolid: 'Solid',
    iconAltTextPositionBottom: 'Onderkant',
    iconAltTextPositionCenter: 'Midden',
    iconAltTextPositionTop: 'Boven',
    inputTextareaPlaceholder: 'Voeg Tekst Toe',
    measurerDateRangeBars: '${value}[number] staven',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Volume ${value}',
    overlayLoadingData: 'Gegevens laden...',
    overlayNoData: 'Geen gegevens om weer te geven',
    overlayNoVisibleSeries: 'Geen zichtbare reeks',
    overlayUnsupportedBrowser: 'Ongeschikte browserversie. Gelieve uw browser te updaten.',
    seriesHistogramTooltipCount: '${yName} (aantal)',
    seriesHistogramTooltipFrequency: 'Frequentie',
    seriesHistogramTooltipMean: '${yName} (gemiddelde)',
    seriesHistogramTooltipSum: '${yName} (som)',
    toolbarAnnotationsArrow: 'Pijl',
    toolbarAnnotationsArrowDown: 'Pijl Omlaag',
    toolbarAnnotationsArrowUp: 'Pijl Omhoog',
    toolbarAnnotationsCallout: 'Tekstballon',
    toolbarAnnotationsClearAll: 'Alles wissen',
    toolbarAnnotationsComment: 'Opmerking',
    toolbarAnnotationsDatePriceRange: 'Datum en Prijs',
    toolbarAnnotationsDateRange: 'Datumbereik',
    toolbarAnnotationsDelete: 'Verwijderen',
    toolbarAnnotationsDisjointChannel: 'Niet-overlappend kanaal',
    toolbarAnnotationsDragHandle: 'Sleepwerkbalk',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib Retracement',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib Trend Gebaseerd',
    toolbarAnnotationsFillColor: 'Vulkleur',
    toolbarAnnotationsHorizontalLine: 'Horizontale lijn',
    toolbarAnnotationsLineAnnotations: 'Trendlijnen',
    toolbarAnnotationsLineColor: 'Lijnkleur',
    toolbarAnnotationsLineStrokeWidth: 'Lijnstreepdikte',
    toolbarAnnotationsLineStyle: 'Lijnstijl',
    toolbarAnnotationsLock: 'Vergrendelen',
    toolbarAnnotationsMeasurerAnnotations: 'Meetinstrumenten',
    toolbarAnnotationsNote: 'Notitie',
    toolbarAnnotationsParallelChannel: 'Parallel Kanaal',
    toolbarAnnotationsPriceRange: 'Prijscategorie',
    toolbarAnnotationsQuickDatePriceRange: 'Meten',
    toolbarAnnotationsSettings: 'Instellingen',
    toolbarAnnotationsShapeAnnotations: 'Pijlen',
    toolbarAnnotationsText: 'Tekst',
    toolbarAnnotationsTextAnnotations: 'Tekstanmerkingen',
    toolbarAnnotationsTextColor: 'Tekstkleur',
    toolbarAnnotationsTextSize: 'Tekstgrootte',
    toolbarAnnotationsTrendLine: 'Trend Lijn',
    toolbarAnnotationsUnlock: 'Ontgrendelen',
    toolbarAnnotationsVerticalLine: 'Verticale lijn',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 maand',
    toolbarRange1Year: '1Jr',
    toolbarRange1YearAria: '1 jaar',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 maanden',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 maanden',
    toolbarRangeAll: 'Alles',
    toolbarRangeAllAria: 'Alles',
    toolbarRangeYearToDate: 'JTD',
    toolbarRangeYearToDateAria: 'Jaar tot nu toe',
    toolbarSeriesTypeCandles: 'Kaarsen',
    toolbarSeriesTypeDropdown: 'Grafiektype',
    toolbarSeriesTypeHighLow: 'Hoog Laag',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Hollow Kaarsen',
    toolbarSeriesTypeLine: 'Lijn',
    toolbarSeriesTypeLineWithMarkers: 'Lijn met Markers',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Stappenlijn',
    toolbarZoomPanEnd: 'Naar het einde pannen',
    toolbarZoomPanLeft: 'Links pannen',
    toolbarZoomPanRight: 'Naar rechts pannen',
    toolbarZoomPanStart: 'Scroll naar het begin',
    toolbarZoomReset: 'Zoom resetten',
    toolbarZoomZoomIn: 'Inzoomen',
    toolbarZoomZoomOut: 'Uitzoomen',
    tooltipPaginationStatus: '${index}[number] van ${count}[number]',
};
